import { defineStore } from 'pinia';
import { iStoreRenameCase } from '@/Interfaces/renameCase';

export const useStoreRenameCase = defineStore('storeRenameCase', {
    state: () :iStoreRenameCase => ({
        renameCaseId: undefined,
        renameCaseCurrentName: '',
    }),
    getters: {

    },
    actions: {
        setRenameCaseId(value?: string | undefined) {
            this.renameCaseId = value;
        },
        setRenameCaseCurrentName(status: string) {
            this.renameCaseCurrentName = status;
        },
        writeRenameCaseParams(id: string, name: string) {
            this.setRenameCaseId(id);
            this.setRenameCaseCurrentName(name);
        },
    },
});
